import { useQuery } from '@tanstack/react-query';
import { useParams } from '@/providers/RouterShim';

import type { ApiResponse } from '../../@types/ApiResponse';
import type { RequestStateQuery } from '../../@types/RequestStateQuery';
import { getJSON } from '../../fetch';
import useAuth from '../../hooks/useAuth';

export interface UnreadMessageCountResponse {
  unreadMessages: number;
}

export const CONVERSATIONS_UNREAD_QUERY = '/api/conversations/unread?id=';

const useUnreadConversationCount = (): [number | undefined, RequestStateQuery] => {
  const { branchId } = useParams();
  const { getToken } = useAuth();

  const { data, isPending, isSuccess, isError } = useQuery<ApiResponse<UnreadMessageCountResponse>>(
    {
      queryKey: [CONVERSATIONS_UNREAD_QUERY, branchId],
      queryFn: async () =>
        await getJSON<ApiResponse<UnreadMessageCountResponse>>(
          `/api/conversations/unread?id=${branchId}`,
          getToken()!,
        ),
      refetchInterval: 60 * 1000,
      enabled: !!branchId,
    },
  );
  return [data?.response.unreadMessages, { isLoading: isPending, isSuccess, isError }];
};

export default useUnreadConversationCount;
